import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface User {
  id: string
  email: string
  name: string
  avatar?: string
  level: number
  exp: number
  createdAt: string
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
}

interface AuthActions {
  setUser: (user: User) => void
  setToken: (token: string) => void
  login: (user: User, token: string) => void
  logout: () => void
  setLoading: (loading: boolean) => void
  updateUser: (updates: Partial<User>) => void
}

export const useAuthStore = create<AuthState & AuthActions>()(
  devtools(
    persist(
      (set, get) => ({
        // State
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: false,

        // Actions
        setUser: (user) => {
          set({ user, isAuthenticated: !!user }, false, 'auth/setUser')
        },

        setToken: (token) => {
          set({ token }, false, 'auth/setToken')
        },

        login: (user, token) => {
          set(
            {
              user,
              token,
              isAuthenticated: true,
              isLoading: false,
            },
            false,
            'auth/login'
          )
        },

        logout: () => {
          set(
            {
              user: null,
              token: null,
              isAuthenticated: false,
              isLoading: false,
            },
            false,
            'auth/logout'
          )
        },

        setLoading: (isLoading) => {
          set({ isLoading }, false, 'auth/setLoading')
        },

        updateUser: (updates) => {
          const { user } = get()
          if (user) {
            set(
              { user: { ...user, ...updates } },
              false,
              'auth/updateUser'
            )
          }
        },
      }),
      {
        name: 'auth-storage',
        partialize: (state) => ({
          user: state.user,
          token: state.token,
          isAuthenticated: state.isAuthenticated,
        }),
      }
    ),
    {
      name: 'auth-store',
    }
  )
)